import filter from 'lodash/filter';
import * as types from './types';
import { uniq, uniqBy } from 'lodash';

export const initialState = {
  isFetching: false,
  error: false,
  errorMessage: '',
  errors: {},
  token: '',
  tokenDuration: 60,
  userAgents: [],
  cloudAgents: [],
  agentExecutions: [],
  resultExecutions: [],
  triggerAgent: {},
  agentTypes: {},
  draftNewAgent: {
    name: '',
    server: '',
    tools: []
  },
  agentsSelected: [],
  agentExecutionsSelected: [],
  lastSelected: -1,
  userAgentsCount: 0,
  showCloudAgents: false,
  cloudAgentsCount: 0,
  agentExecutionsCount: 0,
  success: ''
};

function agents (state = initialState, action) {
  switch (action.type) {
    case types.AGENTS_FETCHING: {
      return {
        ...state,
        isFetching: true,
        error: false,
        errorMessage: '',
        errors: {}
      };
    }

    case types.AGENTS_GET_USER_AGENTS: {
      return {
        ...state,
        isFetching: false,
        error: false,
        userAgents: action.userAgents,
        userAgentsCount: action.count
      };
    }

    case types.AGENTS_GET_CLOUD_AGENTS: {
      return {
        ...state,
        isFetching: false,
        error: false,
        cloudAgents: action.cloudAgents,
        cloudAgentsCount: action.count
      };
    }

    case types.AGENTS_FAIL: {
      return {
        ...state,
        isFetching: false,
        error: true,
        errorMessage: action.errorMessage,
        errors: action.errors
      };
    }

    case types.AGENTS_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        error: false,
        errorMessage: '',
        errors: {}
      };
    }

    case types.AGENTS_GET_TOKEN: {
      return {
        ...state,
        isFetching: false,
        error: false,
        token: action.token,
        tokenExpiresIn: action.tokenExpiresIn,
        tokenDuration: action.tokenDuration
      };
    }

    case types.GET_USER_AGENT_REQUEST: {
      return {
        ...state,
        isFetchingAgent: true,
        error: false
      };
    }

    case types.GET_USER_AGENT_SUCCESS: {
      return {
        ...state,
        isFetchingAgent: false,
        error: false,
        triggerAgent: action.agent
      };
    }

    case types.GET_USER_AGENT_FAIL: {
      return {
        ...state,
        isFetchingAgent: false,
        error: true,
        errorMessage: action.errorMessage
      };
    }

    case types.AGENTS_RUN_SET_WORKSPACES: {
      return {
        ...state,
        triggerAgent: {
          ...state.triggerAgent,
          executors: uniq([...state.triggerAgent.executors, action.newExecutor])
        }
      };
    }

    case types.AGENTS_RUN_SET_SEVERITY_RANGE: {
      return {
        ...state,
        triggerAgent: {
          ...state.triggerAgent,
          severityRange: action.severityRange
        }
      };
    }

    case types.AGENTS_RUN_SET_RESOLVE_HOSTNAME: {
      return {
        ...state,
        triggerAgent: {
          ...state.triggerAgent,
          resolveHostname: action.resolveHostname
        }
      };
    }

    case types.AGENTS_CREATE_WIZARD_RESET: {
      return {
        ...state,
        isFetching: false,
        error: false,
        draftNewAgent: initialState.draftNewAgent
      };
    }

    case types.AGENTS_CREATE_WIZARD_ADD_TOOL: {
      return {
        ...state,
        isFetching: false,
        error: false,
        draftNewAgent: {
          ...state.draftNewAgent,
          tools: [...state.draftNewAgent.tools, action.tool]
        }
      };
    }

    case types.AGENTS_CREATE_WIZARD_REMOVE_TOOL: {
      return {
        ...state,
        isFetching: false,
        error: false,
        draftNewAgent: {
          ...state.draftNewAgent,
          tools: filter(state.draftNewAgent.tools, (e) => (e.name !== action.tool))
        }
      };
    }

    case types.AGENTS_CREATE_WIZARD_SET_FIELDS_TOOL: {
      // se reemplaza el objeto con newitem.
      const newItem = [
        { name: action.toolName, variables: action.fields }
      ];
      const tools = state.draftNewAgent.tools.map((obj) => newItem.find((o) => o.name === obj.name) || obj); // busco el objeto y reemplazo.

      return {
        ...state,
        isFetching: false,
        error: false,
        draftNewAgent: {
          ...state.draftNewAgent,
          tools
        }
      };
    }

    case types.AGENTS_GET_MANIFEST: {
      return {
        ...state,
        agentTypes: action.data
      };
    }

    case types.SET_NEW_AGENT: {
      return {
        ...state,
        draftNewAgent: {
          ...action.data
        }
      };
    }

    case types.RESET_NEW_AGENT: {
      return {
        ...state,
        draftNewAgent: initialState.draftNewAgent
      };
    }

    case types.AGENT_SELECTED: {
      return {
        ...state,
        agentsSelected: uniq([...state.agentsSelected, ...action.payload])
      };
    }
    case types.AGENT_UNSELECTED: {
      const filterByID = (array, id) => array.filter((el) => el.id !== id);
      const newAgentsSelected = action.payload.reduce((agentsSelected, agentToDelete) => filterByID(agentsSelected, agentToDelete.id), state.agentsSelected);

      return {
        ...state,
        agentsSelected: newAgentsSelected
      };
    }
    case types.NEW_PIVOT: {
      return {
        ...state,
        lastSelected: action.payload
      };
    }
    case types.SELECT_ALL_AGENT: {
      return {
        ...state,
        agentsSelected: [...action.agentsList]
      };
    }
    case types.UNSELECT_ALL_AGENT: {
      return {
        ...state,
        agentsSelected: []
      };
    }
    case types.TOGGLE_AGENTS_TAB: {
      return {
        ...state,
        showCloudAgents: !state.showCloudAgents,
        agentsSelected: []
      };
    }

    case types.AGENTS_RESET_STATE: {
      return {
        ...initialState
      };
    }

    case types.AGENTS_SET_TOOL_SELECTED: {
      return {
        ...state,
        triggerAgent: {
          ...state.triggerAgent,
          toolSelected: action.tool
        }
      };
    }

    case types.SAVE_AGENT_TOOL_DATA_SUCCESS: {
      return {
        ...state
      };
    }

    case types.GET_AGENT_EXECUTIONS: {
      return {
        ...state,
        agentExecutions: action.response.rows,
        agentExecutionsCount: action.response.count,
        isFetching: false
      };
    }

    case types.MULTIPLE_AGENT_EXECUTIONS_SET_SELECTED: {
      return {
        ...state,
        agentExecutionsSelected: uniqBy([...state.agentExecutionsSelected, action.agent], 'id')
      };
    }

    case types.AGENT_EXECUTIONS_SET_SELECTED: {
      return {
        ...state,
        agentExecutionsSelected: [action.agent]
      };
    }

    case types.GET_RESULT_EXECUTIONS: {
      return {
        ...state,
        resultExecutions: uniqBy([...state.resultExecutions, action.results], 'workspaceName'),
        isFetching: false
      };
    }

    case types.UNSELECT_ALL_AGENTS_EXECUTIONS: {
      return {
        ...state,
        agentExecutionsSelected: []
      };
    }

    case types.UNSELECT_AGENTS_EXECUTIONS: {
      return {
        ...state,
        agentExecutionsSelected: state.agentExecutionsSelected.filter(
          (e) => e.id !== action.agent.id
        )
      };
    }

    case types.SELECT_ALL_AGENT_EXECUTIONS: {
      return {
        ...state,
        agentExecutionsSelected: [...action.agentExecutionsList]
      };
    }

    case types.AGENTS_SET_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        error: false,
        errorMessage: '',
        errors: {},
        success: action.message
      };
    }

    case types.AGENTS_CLEAR_SUCCESS: {
      return {
        ...state,
        success: ''
      };
    }

    case types.AGENTS_RESET_DETAIL: {
      return {
        ...state,
        triggerAgent: {}
      };
    }

    case types.AGENTS_DETAIL_SET_RESOLVE_HOSTNAME: {
      return {
        ...state,
        triggerAgent: {
          ...state.triggerAgent,
          executors: uniq([...state.triggerAgent.executors, action.newExecutor])
        }
      };
    }

    case types.AGENTS_DETAIL_SET_SEVERITY_RANGE: {
      return {
        ...state,
        triggerAgent: {
          ...state.triggerAgent,
          executors: uniq([...state.triggerAgent.executors, action.newExecutor])
        }
      };
    }

    case types.RESET_RESULT_EXECUTIONS: {
      return {
        ...state,
        resultExecutions: []
      };
    }

    default: {
      return state;
    }
  }
}

export default agents;
